import { useStyletron } from '@thanx/uikit/theme'
import Spinner from 'components/Spinner'
import useFetch from 'hooks/useFetch'
import { Fields as Merchant } from 'models/Merchant'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import LookerError from './components/LookerError'
type PropsT = {
  path: string
  merchant: Merchant
  height?: string
  urlParams?: Record<string, string>
}

const LookerIframe: React.FC<PropsT> = props => {
  const { path, merchant, height: initialHeight, urlParams } = props
  const [currentHeight, setCurrentHeight] = useState<string | undefined>(
    initialHeight || undefined
  )
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const elementID = `looker-${path}`

  useEffect(() => {
    const handleHeightChange = (event: MessageEvent) => {
      const data =
        typeof event.data === 'string' ? JSON.parse(event.data) : event.data
      // Check if this is a Looker page properties message
      if (data?.type === 'page:properties:changed') {
        if (data.height) {
          setCurrentHeight(`${data.height}px`)
        }
      }
    }

    window.addEventListener('message', handleHeightChange)

    return () => {
      window.removeEventListener('message', handleHeightChange)
    }
  }, [])

  // Constructing URL parameters
  let targetPath = path
  if (urlParams) {
    const params = new URLSearchParams(urlParams)
    targetPath += `?${params.toString()}`
  }

  const config = useMemo(
    () => ({
      method: 'GET',
      url: `${merchant.id}/looker/embed_url`,
      params: {
        target_path: targetPath,
      },
    }),
    [merchant, targetPath]
  )
  const { isLoading, response, errors } = useFetch(config)
  const [css] = useStyletron()
  if (errors) return <LookerError />

  const url = response?.data.url
  const heightClass = path.includes('dashboard') ? 'h-100' : 'h-50'

  return (
    <div>
      <iframe
        data-testid="LookerIframe"
        ref={iframeRef}
        id={elementID}
        src={url}
        title={path}
        className={`w-100 border-0 ${!currentHeight && heightClass} ${
          currentHeight && css({ height: currentHeight })
        }`}
      />
      <Spinner
        isLoading={isLoading}
        size="4x"
        className="text-center w-100 absolute t-0"
      />
    </div>
  )
}

export default LookerIframe
